import * as React from "react";

const FIELD_EDITOR_PORTAL_SELECTOR = "[data-field-editor-portal]";

export function shouldCommitOnBlur(event: React.FocusEvent<HTMLElement>): boolean {
  const portal = event.currentTarget.closest(FIELD_EDITOR_PORTAL_SELECTOR);
  const nextFocus = event.relatedTarget;

  if (!portal || !nextFocus || !("nodeType" in nextFocus)) {
    return true;
  }

  return !portal.contains(nextFocus);
}
